import React from "react";
import { MdShoppingCart, MdLocalShipping, MdPayment, MdCheckCircle } from "react-icons/md";
import { useTheme } from "../context/ThemeContext";

const STEPS = [
  { id: 1, label: "Carrito",       icon: MdShoppingCart },
  { id: 2, label: "Envío",         icon: MdLocalShipping },
  { id: 3, label: "Pago",          icon: MdPayment },
  { id: 4, label: "Confirmación",  icon: MdCheckCircle },
];

const CheckoutStepper = ({ currentStep }) => {
  const { getColor } = useTheme();

  const primary  = getColor("background", "#ae1d22");
  const done     = "#16a34a";
  const pending  = "#d1d5db";
  const textDone = "#16a34a";
  const textActive = primary;
  const textPending = "#9ca3af";

  return (
    <div className="w-full flex items-center justify-center mb-8 px-2">
      {STEPS.map((step, index) => {
        const isDone    = step.id < currentStep;
        const isActive  = step.id === currentStep;
        const Icon      = step.icon;

        const circleBg    = isDone ? done : isActive ? primary : "#f3f4f6";
        const iconColor   = isDone || isActive ? "#ffffff" : pending;
        const labelColor  = isDone ? textDone : isActive ? textActive : textPending;
        const lineColor   = step.id < currentStep ? done : pending;

        return (
          <React.Fragment key={step.id}>
            <div className="flex flex-col items-center gap-1.5 min-w-[48px]">
              <div
                className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300"
                style={{
                  backgroundColor: circleBg,
                  transform: isActive ? "scale(1.1)" : "scale(1)",
                  boxShadow: isActive ? `0 0 0 3px ${primary}30` : "none",
                }}>
                <Icon size={18} color={iconColor} />
              </div>
              <span
                className="text-[11px] font-medium hidden sm:block tracking-wide"
                style={{ color: labelColor }}>
                {step.label}
              </span>
            </div>

            {index < STEPS.length - 1 && (
              <div
                className="flex-1 h-[1.5px] mx-1 transition-all duration-300"
                style={{ backgroundColor: lineColor }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CheckoutStepper;
